/* global rp$, window */

import './collect_vin_form.scss';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Collect VIN Form module
	 * -----------------------------------------
	 * @section collect_vin_form_js
	 ********************************************/
	(function CollectVINFormModule() {
		'use strict';

		$onReady({
			rp$, window,
			label: 'collect_vin_form',
			fn: function () {


				const $collectVinModules = rp$('.collect-vin-form-module');
				rp$.each($collectVinModules, function CollectVINFormModule_Iterator(idx, collectVinModuleEle) {
					const $collectVinModuleEle = rp$(collectVinModuleEle);
					const $successEle = $collectVinModuleEle.find('.collect-vin-form-success');
					const $errorsEle = $collectVinModuleEle.find('.form-errors');

					// Handle VIN
					const findVinUrl = `https://cdn.revolutionparts.com/assets/images/find_vin.gif`;
					$collectVinModuleEle.find('.popover-tooltip-test').popover({
						trigger: 'focus',
						placement: 'bottom',
						content: `<img class="wheres-my-vin" src="${findVinUrl}"/>`,
						html: true,
						container: 'body',
					});

					function collectVINWorking() {
						$collectVinModuleEle.find('.vin-form-button').prop('disabled', true);
					}
					function collectVINReady() {
						$collectVinModuleEle.find('.vin-form-button').prop('disabled', false);
					}

					function collectVINHandleErrors(errors) {

						/* Fill errors
						.*-----------------------------------------*/
						$errorsEle.show().empty();
						for(let i = 0, j = errors.length; i < j; i++) {
							const errMsg = errors[i];
							$errorsEle.append('<p>'+ errMsg +'</p>');
						}

						/* If errors are out of view (above or below window pane), scroll to it
						.*-----------------------------------------*/
						const errorsEleOffset = $errorsEle.offset();
						const windowHeight = rp$(window).height();
						const windowTop = rp$(window).scrollTop();
						if((errorsEleOffset.top < windowTop) || (errorsEleOffset.top > (windowTop + windowHeight))) {
							rp$('html, body').animate({
								scrollTop: $errorsEle.offset().top - 40
							});
						}
					}

					function collectVINHandleSuccess() {
						$successEle.fadeIn();
						$errorsEle.hide().empty();
					}

					function collectVINSubmit() {
						$successEle.hide();
						$errorsEle.hide().empty();

						const form = {
							vin: null,
						};

						/* Pull in data from the form and validate
						.*-----------------------------------------*/
						form.vin = $collectVinModuleEle.find('.vin-field').val();
						const isValidLength = (typeof form.vin === 'string' && form.vin.length === 17);
						if (!form.vin || !isValidLength) {
							return collectVINHandleErrors([$collectVinModuleEle.data('error-invalid-vin')]);
						}


						/* Perform Submission
						.*-----------------------------------------*/
						collectVINWorking();
						window.rp_app.request({
							method: 'POST',
							url: '/ajax/collect-vin',
							dataType: 'json',
							data: form,
							success: function collectVINSubmit_Success(/*response*/) {
								collectVINReady();
								collectVINHandleSuccess();
							},
							statusCode: {
								400: function(jqxhr) {
									collectVINReady();
									var error_details;
									if(jqxhr.hasOwnProperty('responseText')) {
										try {
											error_details = JSON.parse(jqxhr.responseText);
										} catch(e) {
											error_details = {
												errors: [$collectVinModuleEle.data('error-400')]
											};
										}
									}
									collectVINHandleErrors(error_details.errors);
								}
							},
							error: function collectVINSubmit_Error(jqxhr/*, status, error*/) {
								if(typeof this.statusCode[jqxhr.status] === 'function') { return; } // StatusCode handled
								collectVINReady();
								collectVINHandleErrors([$collectVinModuleEle.data('error-500')]);
							}
						});
					}

					$collectVinModuleEle.on('click', '.vin-form-button', function (evt) {
						evt.preventDefault();
						if(rp$(this).hasClass('disabled')) {
							return;
						}

						collectVINSubmit();
					});
				});
			},
		});

	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
